import React, { useContext } from "react"
import { PageContext } from "../context/pageContext"
import { SectionContext } from "../context/sectionContext"
import { ErrorContext } from "../context/errorContext"

const RightSideBar = (props) => {

  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [errorState, setErrorState] = useContext(ErrorContext)

  function navigatingEntireSection(index) {
    if (index < props.currentSectionIndex) {
      console.log(pageState.pageData, "sdadsa")
      let foundSection = pageState.pageData.findIndex(section => section.sectionId === props.sections[index].sectionId)
      if(foundSection !== -1){
        props.setCurrentSectionIndex(index)
        props.setShowMainButtonFlexiEdgePlan(true)
        setErrorState({})
        setSectionState({
          sectionId: pageState.pageData?.[foundSection]?.sectionId,
          sectionData: pageState.pageData?.[foundSection]?.sectionData
        })

      }
    }
  }

  let currentSubSectionParentName = ""
  let  sideBar = props.sections?.map((section, index, arr) => {
    if(section.isSubsection){
      if(currentSubSectionParentName === ""){
        currentSubSectionParentName = section.ParentSectionName
      }else if(currentSubSectionParentName === section.ParentSectionName){
        return
      }else{
        currentSubSectionParentName = section.ParentSectionName
      }
      let temp = props.sections.filter(section => section.ParentSectionName === currentSubSectionParentName)

      return (
      <li className={`${index <= props.currentSectionIndex ? "active" : ""} ${props.channelForColorChange == "C" ? "currentSectionNew": ""}`}  key={section.sectionId} >
        <a>
          <span className="fa fa-angle-right" style={{color:index <= props.currentSectionIndex?'#fff':'#ccc'}} ></span>
          <p>{section.ParentSectionName}</p>
        </a>
        {(index <= props.currentSectionIndex && props.currentSectionIndex < (index + temp.length) ) && 
        <ul className="second-right-progress-new-design">
          {temp.map((subSection, idx) => {
            return (<li className={`${(index + idx) <= props.currentSectionIndex ? "active" : ""}`}>
                      <span className={`line-sectond-progress ${(index + idx) <= props.currentSectionIndex ? "active" : ""}`}></span>{subSection.name}
                    </li>)
          })}
        </ul>
        }
        {/* <div className="liner">
          {temp.map((subSection, idx) => {
            return (<div className={`${(index + idx) <= props.currentSectionIndex ? "prs" : " "}`}></div>)
          })}
        </div> */}
        {/* <div className="liner"></div> */}
      </li>)
    }else{
      return (
        <li aria-hidden="true" onClick={() => { navigatingEntireSection(index) }} className={`${index <= props.currentSectionIndex ? "active" : ""}  ${index == props.currentSectionIndex  && props.channelForColorChange  == "C" ? "currentSectionForCanara" :index == props.currentSectionIndex  && props.channelForColorChange  == "A" || props.channelForColorChange  == "28" || props.channelForColorChange  == "35" ? "currentSectionForHsbc": "" } ${index < props.currentSectionIndex  && props.channelForColorChange  == "C" ? "currentSectionCommon" : "currentSection" } ${index < props.currentSectionIndex ? "cursorHover" : "currentSectionCommon"}`}  key={section.sectionId} >
        <a
        >
          <span className="fa fa-angle-right" style={{color:index <= props.currentSectionIndex?'#fff':'#ccc'}}></span>
          <p>{section.name}</p>
        </a>
        <div className={`${index < arr.length-1 ? "liner" : "d-none"} ${index <= props.currentSectionIndex ? "prs" : " "}`}></div>
      </li>)
    }
  })
  
  return (
    <>
      <style>
        {`
          .d-none{
            display: none;
          }
        `}
      </style>
      <div className="col-md-3 right-box-design-size mg-ckyc-top desktop-view-right-side">
        <div className="right-side-progressbar-new-design">
          <ul className="first-right-progress-new-design">
            {sideBar}
          </ul>
        </div>
      </div>
    </>
  )
}

export default RightSideBar
